/* eslint-disable */
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import moment from 'moment';
import { FileText, BarChart2 } from "lucide-react";
import { Drawer, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import { LineChart, DonutChart, MRRBarChart, AssessmentLineChart } from './DahboardLineChart';
import adminServices from '../services/adminServices';
import ResponsiveTable from '../components/Table/Responsivetable';
import Engagement from './Dashboardutils';
import AssessmentUtils from './Assessmentreport_utils'


const mockPlatformHealth = {
  totalB2CSubscribers: 646,
  activeB2CLearners: 10,
  newB2CSignups: 8,
  totalB2BLearners: 26,
  chartDates: [
    '24 Feb', '25 Feb', '26 Feb', '27 Feb', '28 Feb',
    '01 Mar', '02 Mar', '03 Mar', '04 Mar', '05 Mar', '06 Mar', '07 Mar',
    '08 Mar', '09 Mar', '10 Mar', '11 Mar', '12 Mar', '13 Mar', '14 Mar',
    '15 Mar', '16 Mar', '17 Mar', '18 Mar', '19 Mar', '20 Mar', '21 Mar',
    '22 Mar', '23 Mar',
  ],
  activeUsers: [4, 3, 2, 2, 1, 1, 3, 3, 2, 3, 2, 1, 1, 3, 3, 3, 3, 3, 3, 3, 6, 3, 1, 1, 3, 2, 1, 3],
  newSignups: [0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0],
};

const mockRevenue = {
  totalMRR: '₹3.95L',
  mrrChange: '+₹8,940 MoM',
  newSubscriptions: 0,
  churnRate: '2.8%',
  plans: [
    { name: 'All Exams Basic', color: '#3B5BDB', subscribers: 187, price: '₹299', mrr: '₹55.9K', mrrVal: 55900 },
    { name: 'All Exams Pro', color: '#2F9E44', subscribers: 142, price: '₹599', mrr: '₹85.1K', mrrVal: 85100 },
    { name: 'All Exams Premium', color: '#9C36B5', subscribers: 89, price: '₹999', mrr: '₹88.9K', mrrVal: 88900 },
    { name: 'JEE Premium', color: '#74C0FC', subscribers: 71, price: '₹999', mrr: '₹70.9K', mrrVal: 70900 },
    { name: 'NEET Pro', color: '#F03E3E', subscribers: 93, price: '₹599', mrr: '₹55.7K', mrrVal: 55700 },
    { name: 'SAT Pro', color: '#F59F00', subscribers: 64, price: '₹599', mrr: '₹38.3K', mrrVal: 38300 },
  ],
};

const mockClientAdmins = {
  totalTenants: 4,
  activeTenants: 4,
  b2bLearners: 26,
  totalARR: '₹22.41L',
  tenants: [
    { name: 'keySkillset Master', status: 'Active', learners: 0, total: 0, arr: '₹0', contractEnd: '—' },
    { name: 'Akash Institute Delhi', status: 'Active', learners: 14, total: 16, arr: '₹14.94L', contractEnd: '01 Jan 2027' },
    { name: 'Penfield Psychiatry', status: 'Active', learners: 0, total: 0, arr: '₹0', contractEnd: '—' },
    { name: 'TechCorp India', status: 'Active', learners: 0, total: 10, arr: '₹7.47L', contractEnd: '01 Mar 2027' },
  ],
};

const getCurrencySymbol = (currency) => {
  const symbols = {
    'USD': '$',
    'INR': '₹',
    'EUR': '€',
    'GBP': '£',
  };
  return symbols[currency?.toUpperCase()] || '$';
};

const PLAN_COLORS = [
  '#3B5BDB', '#2F9E44', '#9C36B5', '#74C0FC',
  '#F03E3E', '#F59F00', '#0CA678', '#E67700', '#862E9C',
];

const REVENUE_PAGE_SIZE = 10;

const generateDateRange = (days) => {
  const dates = [];
  for (let i = days - 1; i >= 0; i--) {
    dates.push(moment().subtract(i, 'days').format('DD MMM'));
  }
  return dates;
};

const fillDateGaps = (days, apiData) => {
  const allDates = generateDateRange(days);
  const dataMap = {};
  (apiData || []).forEach((r) => {
    const key = moment(r.activity_date).format('DD MMM');
    dataMap[key] = {
      logins: Number(r.logins || 0),
      new_signups: Number(r.new_signups || 0),
    };
  });

  const chartDates = allDates;
  const activeUsers = allDates.map((d) => dataMap[d]?.logins ?? 0);
  const newSignups = allDates.map((d) => dataMap[d]?.new_signups ?? 0);

  return { chartDates, activeUsers, newSignups };
};

const ASSESSMENT_ACTIVITY_PERIODS = [
  { key: 'today', label: 'Today' },
  { key: 'yesterday', label: 'Yesterday' },
  { key: 'thisWeek', label: 'This Week' },
  { key: 'lastWeek', label: 'Last Week' },
  { key: 'thisMonth', label: 'This Month' },
  { key: 'lastMonth', label: 'Last Month' },
  { key: 'sixMonths', label: '6 Months' },
  { key: 'oneYear', label: '1 Year' },
  { key: '', label: 'All' },
];

const getAssessmentActivityRange = (key) => {
  const now = moment();
  let from;
  let to;

  switch (key) {
    case 'today':
      from = now.clone().startOf('day');
      to = now.clone().endOf('day');
      break;
    case 'yesterday':
      from = now.clone().subtract(1, 'day').startOf('day');
      to = now.clone().subtract(1, 'day').endOf('day');
      break;
    case 'thisWeek':
      from = now.clone().startOf('week');
      to = now.clone().endOf('week');
      break;
    case 'lastWeek':
      from = now.clone().subtract(1, 'week').startOf('week');
      to = now.clone().subtract(1, 'week').endOf('week');
      break;
    case 'thisMonth':
      from = now.clone().startOf('month');
      to = now.clone().endOf('month');
      break;
    case 'lastMonth':
      from = now.clone().subtract(1, 'month').startOf('month');
      to = now.clone().subtract(1, 'month').endOf('month');
      break;
    case 'sixMonths':
      from = now.clone().subtract(6, 'months').startOf('day');
      to = now.clone().endOf('day');
      break;
    case 'oneYear':
      from = now.clone().subtract(1, 'year').startOf('day');
      to = now.clone().endOf('day');
      break;
    case '': return { fromDate: '', toDate: '' };

    default:
      from = now.clone().startOf('day');
      to = now.clone().endOf('day');
  }

  return { fromDate: from.format('YYYY-MM-DD'), toDate: to.format('YYYY-MM-DD') };
};

const IconUsers = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const IconTrend = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" /><polyline points="16 7 22 7 22 13" />
  </svg>
);
const IconUserPlus = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="8.5" cy="7" r="4" />
    <line x1="20" y1="8" x2="20" y2="14" /><line x1="23" y1="11" x2="17" y2="11" />
  </svg>
);
const IconBuilding = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);
const IconRupee = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="6" y1="4" x2="18" y2="4" /><line x1="6" y1="9" x2="18" y2="9" />
    <path d="M6 14l12 6" /><path d="M6 9a6 6 0 0 0 0 11" />
  </svg>
);
const IconPercent = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="5" x2="5" y2="19" /><circle cx="6.5" cy="6.5" r="2.5" /><circle cx="17.5" cy="17.5" r="2.5" />
  </svg>
);
const IconCheck = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);
const IconAssessment = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
  </svg>
);

function StatCard({ icon, label, value, sub, subGreen = true }) {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3.5">
      <div className="flex items-center gap-1 text-gray-500 mb-2">
        {icon}
        <span className="text-xs font-semibold tracking-wider uppercase">{label}</span>
      </div>
      <div className="text-2xl font-bold text-gray-900 leading-none mb-1">{value ?? '—'}</div>
      <div className={`text-xs font-medium ${subGreen ? 'text-green-600' : 'text-gray-500'}`}>{sub}</div>
    </div>
  );
}

function LoadingSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-white border border-gray-200 rounded-lg p-3.5 h-24">
            <div className="h-3 bg-gray-200 rounded w-2/3 mb-3" />
            <div className="h-7 bg-gray-200 rounded w-1/3 mb-2" />
            <div className="h-2 bg-gray-200 rounded w-1/2" />
          </div>
        ))}
      </div>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <div className="h-4 bg-gray-200 rounded w-32 mb-2" />
        <div className="h-3 bg-gray-200 rounded w-48 mb-4" />
        <div className="h-44 bg-gray-100 rounded" />
      </div>
    </div>
  );
}

function PlatformHealth({ data, loading, period }) {
  if (loading) return <LoadingSkeleton />;

  const chartData = (data?.chartDates?.length > 0) ? data : mockPlatformHealth;

  const fromDate = moment().subtract(Number(period) - 1, 'days').format('DD MMM YYYY');
  const toDate = moment().format('DD MMM YYYY');

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
        <StatCard
          icon={<IconUsers />}
          label="Total B2C Subscribers"
          value={data?.totalB2CSubscribers}
          sub="total subscribers"
        />
        <StatCard
          icon={<IconTrend />}
          label="Active B2C Learners"
          value={data?.activeB2CLearners}
          sub={`logins · last ${period}d`}
        />
        <StatCard
          icon={<IconUserPlus />}
          label="New B2C Signups"
          value={data?.newB2CSignups}
          sub="growing steadily"
        />
        <StatCard
          icon={<IconBuilding />}
          label="Total B2B Learners"
          value={data?.totalB2BLearners}
          sub="2 active tenants"
        />
      </div>

      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <div className="flex items-center justify-between mb-0.5">
          <div className="text-sm font-bold text-gray-900">Daily Activity</div>
          <div className="text-xs text-gray-400">{fromDate} — {toDate}</div>
        </div>
        <div className="text-xs text-gray-400 mt-0.5 mb-3">
          Active learners and new B2C sign-ups per day
        </div>
        <LineChart
          key={`${period}-${chartData.chartDates?.[0]}`}
          dates={chartData.chartDates}
          series1={chartData.activeUsers}
          series2={chartData.newSignups}
        />
      </div>
    </>
  );
}

function Revenue({ data, loading, period, page, onPageChange }) {
  if (loading) return <LoadingSkeleton />;

  const currencySymbol = getCurrencySymbol(data?.currency);

  const formatMRR = (val) => {
    if (val === undefined || val === null) return `${currencySymbol}0`;
    return `${currencySymbol}${Number(val).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const chartPlans = (data?.chart || []).map((p, i) => ({
    name: p.plan_name,
    subscribers: p.subscribers,
    mrrVal: p.mrr,
    mrr: formatMRR(p.mrr),
    price: `${currencySymbol}${Number(p.price || 0).toFixed(2)}`,
    color: PLAN_COLORS[i % PLAN_COLORS.length],
  }));

  const displayChartPlans = chartPlans.length > 0 ? chartPlans : mockRevenue.plans;

  const maxMRRVal = Math.max(...displayChartPlans.map(p => p.mrrVal || 0), 1);

  const getNiceAxisMax = (max) => {
    const exp = Math.floor(Math.log10(max));
    const frac = max / Math.pow(10, exp);
    let nice;
    if (frac <= 1) nice = 1;
    else if (frac <= 2) nice = 2;
    else if (frac <= 2.5) nice = 2.5;
    else if (frac <= 5) nice = 5;
    else nice = 10;
    return nice * Math.pow(10, exp);
  };

  const axisMax = getNiceAxisMax(maxMRRVal);
  const axisTicks = [0, 1, 2, 3, 4].map(i => Math.round((axisMax / 4) * i));

  const tablePlans = data?.plans || [];
  const pagination = data?.pagination || {};
  const totalPages = pagination.total_pages || 1;
  const totalPlans = pagination.total || 0;
  const currentPage = pagination.page || 1;

  const totalMrrDisplay = data ? formatMRR(data.total_mrr) : mockRevenue.totalMRR;
  const newSubscriptionsDisplay = data ? data.new_subscriptions : mockRevenue.newSubscriptions;
  const churnRateDisplay = data ? `${data.churn_rate}%` : mockRevenue.churnRate;

  const pageMrrSum = tablePlans.reduce((s, p) => s + (p.mrr || 0), 0);
  const pageSubsSum = tablePlans.reduce((s, p) => s + (p.subscribers || 0), 0);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
        <StatCard icon={<IconRupee />} label="Total MRR" value={totalMrrDisplay} sub="all active subscriptions" />
        <StatCard icon={<IconTrend />} label="New Subscriptions" value={newSubscriptionsDisplay} sub={`in last ${period} days`} subGreen={false} />
        {/* <StatCard icon={<IconPercent />} label="Churn Rate" value={churnRateDisplay} sub="static estimate" subGreen={false} /> */}
      </div>

      <div className="grid grid-cols-1 gap-3 mb-4">
        {/* <div className="bg-white border border-gray-200 rounded-lg p-4">
          <div className="text-xs font-semibold text-gray-600 mb-3">Subscribers by Plan</div>
          <DonutChart plans={displayChartPlans} />
        </div> */}
        <div className="bg-white border border-gray-200 rounded-lg p-4">
          <div className="text-xs font-semibold text-gray-600 mb-3">MRR by Plan</div>
          <MRRBarChart plans={displayChartPlans} currencySymbol={currencySymbol} axisMax={axisMax} axisTicks={axisTicks} />
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="px-4 pt-4 pb-1">
          <div className="text-sm font-bold text-gray-900">Plan Breakdown</div>
          <div className="text-xs text-gray-400 mt-0.5 mb-2">
            Subscriptions created in the last {period} days
          </div>
        </div>

        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-50">
              <th className="text-left px-4 py-2.5 text-xs font-semibold tracking-wider uppercase text-gray-400 border-b border-gray-100">Plan</th>
              <th className="text-right px-4 py-2.5 text-xs font-semibold tracking-wider uppercase text-gray-400 border-b border-gray-100">Subscribers</th>
              <th className="text-right px-4 py-2.5 text-xs font-semibold tracking-wider uppercase text-gray-400 border-b border-gray-100">Price / Month</th>
              <th className="text-right px-4 py-2.5 text-xs font-semibold tracking-wider uppercase text-gray-400 border-b border-gray-100">MRR</th>
              <th className="text-right px-4 py-2.5 text-xs font-semibold tracking-wider uppercase text-gray-400 border-b border-gray-100">Added On</th>
            </tr>
          </thead>
          <tbody>
            {tablePlans.length > 0
              ? tablePlans.map((p, i) => (
                <tr key={p.plan_id || i} className="border-b border-gray-50 hover:bg-gray-50 transition-colors">
                  <td className="px-4 py-2.5 text-xs text-gray-700">{p.plan_name}</td>
                  <td className="px-4 py-2.5 text-xs text-gray-700 text-right">{p.subscribers}</td>
                  <td className="px-4 py-2.5 text-xs text-gray-700 text-right">
                    {currencySymbol}{Number(p.price || 0).toFixed(2)}
                  </td>
                  <td className="px-4 py-2.5 text-xs text-gray-700 text-right">
                    {formatMRR(p.mrr)}
                  </td>
                  <td className="px-4 py-2.5 text-xs text-gray-400 text-right">
                    {p.added_on ? moment(p.added_on).format('DD MMM YYYY') : '—'}
                  </td>
                </tr>
              ))
              : (
                <tr>
                  <td colSpan={5} className="px-4 py-6 text-center text-xs text-gray-400">
                    No plans found for the selected period.
                  </td>
                </tr>
              )
            }

            {/* ── Page footer row ── */}
            <tr className="bg-gray-50">
              <td className="px-4 py-2.5 text-xs font-semibold text-gray-900">
                Page MRR ({tablePlans.length} plans)
              </td>
              <td className="px-4 py-2.5 text-xs text-gray-400 text-right">{pageSubsSum}</td>
              <td></td>
              <td className="px-4 py-2.5 text-xs font-semibold text-gray-900 text-right">
                {formatMRR(pageMrrSum)}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>

        {/* ── Pagination ── */}
        {totalPages > 1 && (
          <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100 bg-gray-50">
            <span className="text-xs text-gray-400">
              Showing {(currentPage - 1) * REVENUE_PAGE_SIZE + 1}–{Math.min(currentPage * REVENUE_PAGE_SIZE, totalPlans)} of {totalPlans} plans
            </span>
            <div className="flex gap-2">
              <button
                disabled={currentPage <= 1}
                onClick={() => onPageChange(currentPage - 1)}
                className="px-3 py-1 text-xs border border-gray-300 rounded disabled:opacity-40 hover:bg-white transition-colors"
              >
                Previous
              </button>
              <span className="text-xs text-gray-600 font-medium px-2 py-1">
                {currentPage} / {totalPages}
              </span>
              <button
                disabled={currentPage >= totalPages}
                onClick={() => onPageChange(currentPage + 1)}
                className="px-3 py-1 text-xs border border-gray-300 rounded disabled:opacity-40 hover:bg-white transition-colors"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

function ClientAdminsSection({ data, loading, error, page, onPageChange, pageSize }) {
  if (error) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="text-center text-sm text-red-600">{error}</div>
      </div>
    );
  }

  if (!data) {
    return <LoadingSkeleton />;
  }

  const { summary, tenants, pagination } = data;
  const totalPages = pagination.totalPages || 1;

  // Define columns for ResponsiveTable
  const columns = [
    {
      label: 'Tenant',
      key: 'name',
      render: (row) => (
        <span className="font-medium text-gray-900">{row.name}</span>
      ),
    },
    {
      label: 'Admin',
      key: 'adminName',
      render: (row) => (
        <div className="truncate max-w-xs" title={row.adminEmail}>
          {row.adminName}
        </div>
      ),
    },
    {
      label: 'Status',
      key: 'status',
      render: (row) => {
        const statusColor = row.status === 'ACTIVE' ? 'text-green-600 bg-green-50' : 'text-gray-500 bg-gray-100';
        const statusLabel = row.status === 'ACTIVE' ? 'Active' : 'Inactive';
        return (
          <span className={`inline-flex items-center gap-1.5 text-xs font-medium px-2 py-0.5 rounded ${statusColor}`}>
            <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: row.status === 'ACTIVE' ? '#22c55e' : '#9ca3af' }} />
            {statusLabel}
          </span>
        );
      },
    },
    {
      label: 'Learners',
      key: 'learners',
      centered: true,
      render: (row) => (
        <span className="text-gray-900">{row.learners}</span>
      ),
    },
    {
      label: 'ARR',
      key: 'arr',
      render: (row) => (
        <span className="font-medium text-gray-900">{row.arr}</span>
      ),
    },
  ];

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
        <StatCard icon={<IconBuilding />} label="Total Tenants" value={summary.totalTenants} sub="all clients" subGreen={false} />
        <StatCard icon={<IconCheck />} label="Active Tenants" value={summary.activeTenants} sub="operational" />
        <StatCard icon={<IconUsers />} label="B2B Learners" value={summary.b2bLearners} sub="across all tenants" subGreen={false} />
        <StatCard icon={<IconRupee />} label="Total ARR" value={summary.totalARR} sub="annual recurring" subGreen={false} />
      </div>

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="px-4 pt-4 pb-1">
          <div className="text-sm font-bold text-gray-900">Tenant Overview</div>
          <div className="text-xs text-gray-400 mt-0.5 mb-2">All B2B tenants and their performance</div>
        </div>

        <div className="px-4 py-3">
          <ResponsiveTable
            columns={columns}
            data={tenants}
            loading={loading}
            emptyStateComponent={
              <div className="text-center py-8 text-xs text-gray-400">
                No tenants found.
              </div>
            }
          />
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100 bg-gray-50">
            <span className="text-xs text-gray-400">
              Showing {page * pageSize + 1}–{Math.min((page + 1) * pageSize, pagination.total)} of {pagination.total} tenants
            </span>
            <div className="flex gap-2">
              <button
                disabled={page === 0}
                onClick={() => onPageChange(page - 1)}
                className="px-3 py-1 text-xs border border-gray-300 rounded disabled:opacity-40 hover:bg-white transition-colors"
              >
                Previous
              </button>
              <span className="text-xs text-gray-600 font-medium px-2 py-1">{page + 1} / {totalPages}</span>
              <button
                disabled={page >= totalPages - 1}
                onClick={() => onPageChange(page + 1)}
                className="px-3 py-1 text-xs border border-gray-300 rounded disabled:opacity-40 hover:bg-white transition-colors"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

const BAR_COLOR_PALETTE = [
  { bg: 'bg-blue-400', hover: 'group-hover:bg-blue-500' },
  { bg: 'bg-purple-400', hover: 'group-hover:bg-purple-500' },
  { bg: 'bg-emerald-400', hover: 'group-hover:bg-emerald-500' },
  { bg: 'bg-amber-400', hover: 'group-hover:bg-amber-500' },
  { bg: 'bg-rose-400', hover: 'group-hover:bg-rose-500' },
  { bg: 'bg-cyan-400', hover: 'group-hover:bg-cyan-500' },
  { bg: 'bg-indigo-400', hover: 'group-hover:bg-indigo-500' },
  { bg: 'bg-orange-400', hover: 'group-hover:bg-orange-500' },
];

function AssessmentActivityBarChart({ data, loading, ASSESSMENT_EXAM_TYPES, onBarClick, selectedExam }) {
  if (loading) {
    return (
      <div className="h-56 flex items-end gap-6 px-1 animate-pulse">
        {ASSESSMENT_EXAM_TYPES.map((exam, i) => (
          <div key={exam.id} className="flex-1 bg-gray-100 rounded-t" style={{ height: `${28 + (i % 4) * 15}%` }} />
        ))}
      </div>
    );
  }

  const maxVal = Math.max(...data.map((d) => d.count), 1);

  const examColorMap = ASSESSMENT_EXAM_TYPES.reduce((acc, exam, i) => {
    acc[exam.id] = BAR_COLOR_PALETTE[i % BAR_COLOR_PALETTE.length];
    return acc;
  }, {});

  return (
    <div className="flex items-end gap-6 px-1 h-56">
      {data.map((d) => {
        const heightPct = Math.max((d.count / maxVal) * 100, 2);
        const clickable = d.count > 0 && typeof onBarClick === 'function';
        const color = examColorMap[d.exam.id] || BAR_COLOR_PALETTE[0];
        const isSelected = selectedExam === d.exam.id;
        return (
          <div key={d.exam.id} className="flex-1 flex flex-col items-center justify-end h-full group/bar">
            <div className={`text-xs font-semibold mb-1 ${isSelected ? 'text-blue-600' : 'text-gray-900'}`}>
              {d.count}
            </div>
            <div
              className={`w-full rounded-t ${color.bg} ${color.hover} transition-all ${clickable ? 'cursor-pointer' : ''} ${isSelected ? 'ring-2 ring-offset-2 ring-blue-500 shadow-md' : ''}`}
              style={{ height: `${heightPct}%`, minHeight: 4 }}
              title={`${d.exam.code}: ${d.count} unique users${clickable ? ' — click to view' : ''}`}
              onClick={() => clickable && onBarClick(d.exam)}
            />
            <div className="w-full mt-2 flex flex-col items-center justify-start gap-1">
              <div className="relative group/label">
                <div
                  className={`text-xs text-center leading-tight ${isSelected ? 'font-bold text-blue-600' : 'font-medium text-gray-500'}`}
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    wordBreak: 'break-word',
                  }}
                >
                  {d.exam.code}
                </div>

                <div
                  className="pointer-events-none absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-10
                             opacity-0 group-hover/label:opacity-100 transition-opacity duration-150
                             whitespace-normal max-w-[200px] text-center
                             bg-gray-900 text-white text-[11px] leading-snug rounded px-2 py-1 shadow-lg"
                >
                  {d.exam.code}
                  <div
                    className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0"
                    style={{
                      borderLeft: '5px solid transparent',
                      borderRight: '5px solid transparent',
                      borderTop: '5px solid #111827',
                    }}
                  />
                </div>
              </div>
              {isSelected && <div className="w-1.5 h-1.5 rounded-full bg-blue-500" />}
            </div>
          </div>
        );
      })}
    </div>
  );
}
function AssessmentActivityCard({ ASSESSMENT_EXAM_TYPES, primaryOnly = false, title, description, onSelectExam, selectedExamUsers }) {
  const isMine = !!selectedExamUsers
    && selectedExamUsers.title === title
    && selectedExamUsers.primaryOnly === primaryOnly;

  const [selectedPeriod, setSelectedPeriod] = useState(() => (isMine ? selectedExamUsers.period : 'today'));
  const [activityData, setActivityData] = useState(
    ASSESSMENT_EXAM_TYPES.map((exam) => ({ exam, count: 0 }))
  );
  const [usersByExam, setUsersByExam] = useState({});
  const [activityLoading, setActivityLoading] = useState(false);
  const [activityError, setActivityError] = useState('');

  const fetchAssessmentActivity = useCallback(async (periodKey) => {
    setActivityLoading(true);
    setActivityError('');
    try {
      const { fromDate, toDate } = getAssessmentActivityRange(periodKey);
      const res = await adminServices.getIndividualListDownload(
        'desc', 'created_at', '', 'null', '', fromDate, toDate, null, "dashboard"
      );
      const list = res?.data?.records || res?.data?.data || res?.data || [];
      const users = Array.isArray(list) ? list : [];

      const usersMap = {};
      const counts = ASSESSMENT_EXAM_TYPES.map((exam) => {
        const matched = users.filter((u) => {
          const assessments = Array.isArray(u?.assessment) ? u.assessment : [];
          if (primaryOnly) {
            const primary = assessments[0];
            return primary?.id === exam.id;
          }
          return assessments.some((a) => a?.id === exam.id);
        });
        usersMap[exam.id] = matched;
        return { exam, count: matched.length };
      });

      setActivityData(counts);
      setUsersByExam(usersMap);
    } catch (err) {
      console.error(err, `failed to [getIndividualListDownload] for period [${periodKey}]`);
      setActivityError('Failed to load assessment activity.');
    } finally {
      setActivityLoading(false);
    }
  }, [primaryOnly, ASSESSMENT_EXAM_TYPES]);

  useEffect(() => {
    fetchAssessmentActivity(selectedPeriod);
  }, [selectedPeriod, fetchAssessmentActivity]);

  const handleBarClick = (exam) => {
    onSelectExam?.({
      exam,
      title,
      period: selectedPeriod,
      primaryOnly,
      users: usersByExam[exam.id] || [],
    });
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between mb-0.5">
        <div className="text-sm font-bold text-gray-900">{title}</div>
        <select
          value={selectedPeriod}
          onChange={(e) => setSelectedPeriod(e.target.value)}
          className="text-xs font-medium text-gray-700 border border-gray-300 rounded px-2 py-1 bg-white cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-500"
        >
          {ASSESSMENT_ACTIVITY_PERIODS.map(({ key, label }) => (
            <option key={key} value={key}>{label}</option>
          ))}
        </select>
      </div>
      <div className="text-xs text-gray-400 mt-0.5 mb-3">{description}</div>

      {activityError ? (
        <div className="text-xs text-red-600 py-6 text-center">{activityError}</div>
      ) : (
        <div className="flex gap-4">
          <div className="flex-1">
            <AssessmentActivityBarChart
              data={activityData}
              loading={activityLoading}
              ASSESSMENT_EXAM_TYPES={ASSESSMENT_EXAM_TYPES}
              onBarClick={handleBarClick}
              selectedExam={isMine ? selectedExamUsers.exam.id : null}
            />
          </div>
        </div>
      )}
    </div>
  );
}

const SELECTED_EXAM_USERS_PAGE_SIZE = 10;

function SelectedExamUsersPanel({ selection, onClose, dashboardPeriod }) {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [selection?.exam, selection?.title, selection?.period]);

  const handleNavigateView = (user) => {
    navigate('/app/individual-usersview', {
      state: {
        ...user,
        __dashboardReturn: {
          tab: 'assessments',
          period: dashboardPeriod,
          selection,
        },
      },
    });
  };

  if (!selection) return null;

  const { exam, title, users = [] } = selection;

  const totalUsers = users.length;
  const totalPages = Math.max(Math.ceil(totalUsers / SELECTED_EXAM_USERS_PAGE_SIZE), 1);
  const currentPage = Math.min(page, totalPages);

  const startIdx = (currentPage - 1) * SELECTED_EXAM_USERS_PAGE_SIZE;
  const endIdx = startIdx + SELECTED_EXAM_USERS_PAGE_SIZE;
  const pageUsers = users.slice(startIdx, endIdx);

  return (
    <div className="bg-white border border-blue-200 rounded-lg overflow-hidden mb-4 ring-1 ring-blue-100">
      <div className="flex items-center justify-between px-4 pt-4 pb-2">
        <div>
          <div className="text-sm font-bold text-gray-900">
            {exam.code} <span className="text-gray-400 font-normal">· {title}</span>
          </div>
          <div className="text-xs text-gray-400 mt-0.5">{totalUsers} users</div>
        </div>
        <button
          onClick={onClose}
          className="text-xs text-gray-400 hover:text-gray-700 px-2 py-1"
        >
          ✕ Close
        </button>
      </div>

      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gray-50">
            <th className="text-left px-4 py-2 text-xs font-semibold uppercase text-gray-400 border-b border-gray-100">Name</th>
            <th className="text-left px-4 py-2 text-xs font-semibold uppercase text-gray-400 border-b border-gray-100">Email</th>
            <th className="text-left px-4 py-2 text-xs font-semibold uppercase text-gray-400 border-b border-gray-100">Status</th>
            <th className="text-right px-4 py-2 text-xs font-semibold uppercase text-gray-400 border-b border-gray-100">Action</th>
          </tr>
        </thead>
        <tbody>
          {pageUsers.length > 0 ? pageUsers.map((u, i) => {
            return (
              <tr key={u.id || startIdx + i} className="border-b border-gray-50 hover:bg-gray-50">
                <td className="px-4 py-2.5 text-xs text-gray-900 font-medium">{u.name || u.full_name || '—'}</td>
                <td className="px-4 py-2.5 text-xs text-gray-700">{u.email || '—'}</td>
                <td className="px-4 py-2.5 text-xs">
                  <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded font-medium ${u.status === 'Active' ? 'text-green-600 bg-green-50' : 'text-gray-500 bg-gray-100'}`}>
                    {u.status || '—'}
                  </span>
                </td>
                <td className="px-4 py-2.5 text-right">
                  <button
                    onClick={() => handleNavigateView(u)}
                    className="text-xs border border-gray-200 text-gray-500 rounded px-3 py-1.5 hover:border-blue-300 hover:text-blue-600 hover:bg-blue-50 transition-colors font-medium"
                  >
                    View
                  </button>
                </td>
              </tr>
            )
          }) : (
            <tr>
              <td colSpan={4} className="px-4 py-6 text-center text-xs text-gray-400">
                No users found for this exam.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100 bg-gray-50">
          <span className="text-xs text-gray-400">
            Showing {startIdx + 1}–{Math.min(endIdx, totalUsers)} of {totalUsers} users
          </span>
          <div className="flex gap-2">
            <button
              disabled={currentPage <= 1}
              onClick={() => setPage(currentPage - 1)}
              className="px-3 py-1 text-xs border border-gray-300 rounded disabled:opacity-40 hover:bg-white transition-colors"
            >
              Previous
            </button>
            <span className="text-xs text-gray-600 font-medium px-2 py-1">
              {currentPage} / {totalPages}
            </span>
            <button
              disabled={currentPage >= totalPages}
              onClick={() => setPage(currentPage + 1)}
              className="px-3 py-1 text-xs border border-gray-300 rounded disabled:opacity-40 hover:bg-white transition-colors"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function Assessments({ data, loading, ASSESSMENT_EXAM_TYPES, period, selectedExamUsers, onSelectExam, onCloseExamUsers, onViewLeaderboard }) {

  if (loading) return <LoadingSkeleton />;
  if (!data) return <div className="p-6 text-xs text-gray-400">No assessment data available.</div>;

  const totalAttemptsFromBreakdown = data.breakdown?.reduce(
    (sum, row) => sum + Number(row.attempts || 0),
    0
  );

  return (
    <>


      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
        <StatCard icon={<IconUsers />} label="Total Users" value={data.totalUsers} sub="unique learners" />
        <StatCard icon={<FileText size={16} className="text-gray-600" />} label="Assessments in Use" value={data.assessmentsInUse} sub="active assessments" />
        <StatCard icon={<BarChart2 size={16} className="text-gray-600" />} label="Total Attempts" value={totalAttemptsFromBreakdown} sub="in selected period" />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
        <AssessmentActivityCard
          ASSESSMENT_EXAM_TYPES={ASSESSMENT_EXAM_TYPES}
          primaryOnly
          title="Primary Assessment Onboarding"
          description="Unique users based on their primary target."
          onSelectExam={onSelectExam}
          selectedExamUsers={selectedExamUsers}
        />
        <AssessmentActivityCard
          ASSESSMENT_EXAM_TYPES={ASSESSMENT_EXAM_TYPES}
          title="Overall Assessment Onboarding"
          description="Unique users across primary and complimentary assessments."
          onSelectExam={onSelectExam}
          selectedExamUsers={selectedExamUsers}
        />
      </div>

      <SelectedExamUsersPanel
        selection={selectedExamUsers}
        onClose={onCloseExamUsers}
        dashboardPeriod={period}
      />

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="px-4 pt-4 pb-1">
          <div className="text-sm font-bold text-gray-900">Per-Assessment Breakdown</div>
        </div>

        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-50 border-t border-b border-gray-100">
              <th className="text-left px-4 py-2 text-xs font-semibold uppercase text-gray-400">Assessment</th>
              <th className="text-right px-4 py-2 text-xs font-semibold uppercase text-gray-400">Total Attempts</th>
              <th className="text-right px-4 py-2 text-xs font-semibold uppercase text-gray-400">Users</th>
              <th className="text-left px-4 py-2 text-xs font-semibold uppercase text-gray-400">Top Scorer</th>
              <th className="text-right px-4 py-2 text-xs font-semibold uppercase text-gray-400">Action</th>
            </tr>
          </thead>
          <tbody>
            {data.breakdown?.length > 0
              ? data.breakdown.map((row, i) => (
                <tr key={i} className="border-b border-gray-50 hover:bg-gray-50">
                  <td className="px-4 py-2.5 text-xs text-gray-700">{row.name}</td>
                  <td className="px-4 py-2.5 text-xs text-right">{row.attempts}</td>
                  <td className="px-4 py-2.5 text-xs text-right">{row.uniqueUsers}</td>
                  <td className="px-4 py-2.5 text-xs text-gray-700">
                    {row.topScorerName}
                    {row.topScorerScore != null && (
                      <span className="text-gray-400"> ({row.topScorerScore}%)</span>
                    )}
                  </td>
                  <td className="px-4 py-2.5 text-xs text-right">
                    <button
                      type="button"
                      onClick={() => onViewLeaderboard?.(row)}
                      disabled={!row.id}
                      className="font-semibold text-blue-600 hover:text-blue-700 hover:underline disabled:text-gray-300 disabled:no-underline disabled:cursor-not-allowed"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
              : (
                <tr>
                  <td colSpan={5} className="px-4 py-6 text-center text-xs text-gray-400">
                    No assessment data for the selected period.
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    </>
  );
}

function AssessmentLeaderboardDrawer({ selection, onClose }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [leaderboard, setLeaderboard] = useState(null);
  const [activeAttempt, setActiveAttempt] = useState(null);

  useEffect(() => {
    if (!selection?.id) {
      setLeaderboard(null);
      setActiveAttempt(null);
      return;
    }

    let cancelled = false;
    const fetchLeaderboard = async () => {
      setLoading(true);
      setError('');
      setLeaderboard(null);
      setActiveAttempt(null);
      try {
        const res = await adminServices.getAssessmentLeaderboard(selection.id);
        if (cancelled) return;
        setLeaderboard(res.data);
        setActiveAttempt(res.data?.attempts?.[0]?.attemptNumber ?? null);
      } catch (err) {
        if (!cancelled) {
          console.error(err, 'failed to [getAssessmentLeaderboard]');
          setError('Failed to load leaderboard.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchLeaderboard();
    return () => { cancelled = true; };
  }, [selection?.id]);

  const rankBadgeColor = (rank) => {
    if (rank === 1) return 'bg-amber-100 text-amber-700';
    if (rank === 2) return 'bg-gray-200 text-gray-700';
    if (rank === 3) return 'bg-orange-100 text-orange-700';
    return 'bg-gray-100 text-gray-500';
  };

  const activeGroup = leaderboard?.attempts?.find((g) => g.attemptNumber === activeAttempt);

  return (
    <Drawer
      anchor="right"
      open={!!selection}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: '100vw', sm: '460px' },
          borderLeft: '1px solid #e5e7eb',
          boxShadow: '-4px 0 24px rgba(0,0,0,0.08)',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {selection && (
        <>
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0">
            <div>
              <div className="text-xs font-semibold uppercase text-gray-400">Leaderboard</div>
              <h2 className="text-base font-bold text-gray-900">{selection.name}</h2>
            </div>
            <IconButton size="small" onClick={onClose} sx={{ color: '#6b7280' }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>

          <div className="px-6 py-5 flex-1 overflow-y-auto">
            {loading && <div className="py-10 text-center text-xs text-gray-400">Loading leaderboard…</div>}
            {!loading && error && <div className="py-10 text-center text-xs text-red-600">{error}</div>}

            {!loading && !error && leaderboard && (
              <>
                <div className="mb-5">
                  <div className="text-xs font-semibold uppercase text-gray-400 mb-2">Top 3 Overall</div>
                  {leaderboard.topThreeOverall?.length > 0 ? (
                    <div className="flex flex-col gap-2">
                      {leaderboard.topThreeOverall.map((u, i) => (
                        <div key={u.userId} className="border border-gray-100 rounded-lg p-3 flex items-center gap-2">
                          <span className={`w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-bold shrink-0 ${rankBadgeColor(i + 1)}`}>
                            {i + 1}
                          </span>
                          <div className="min-w-0">
                            <div className="text-xs font-semibold text-gray-900 truncate">{u.name}</div>
                            <div className="text-[11px] text-gray-500">{u.bestScore}% · attempt {u.attemptNumber}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-xs text-gray-400">No scored attempts yet.</div>
                  )}
                </div>

                <div className="text-xs font-semibold uppercase text-gray-400 mb-2">By Attempt</div>
                {leaderboard.attempts?.length > 0 ? (
                  <>
                    <div className="flex items-center gap-1 border-b border-gray-200 mb-3 overflow-x-auto">
                      {leaderboard.attempts.map((group) => (
                        <button
                          key={group.attemptNumber}
                          type="button"
                          onClick={() => setActiveAttempt(group.attemptNumber)}
                          className={`px-3 py-2 text-xs font-semibold border-b-2 -mb-px whitespace-nowrap transition-colors ${activeAttempt === group.attemptNumber
                              ? 'border-blue-600 text-blue-600'
                              : 'border-transparent text-gray-500 hover:text-gray-700'
                            }`}
                        >
                          Attempt {group.attemptNumber}
                        </button>
                      ))}
                    </div>

                    {activeGroup && (
                      <div className="border border-gray-100 rounded-lg overflow-hidden">
                        <table className="w-full border-collapse">
                          <thead>
                            <tr className="border-b border-gray-100 bg-gray-50">
                              <th className="text-left px-3 py-1.5 text-[10.5px] font-semibold uppercase text-gray-400">Rank</th>
                              <th className="text-left px-3 py-1.5 text-[10.5px] font-semibold uppercase text-gray-400">Name</th>
                              <th className="text-left px-3 py-1.5 text-[10.5px] font-semibold uppercase text-gray-400">Email</th>
                              <th className="text-right px-3 py-1.5 text-[10.5px] font-semibold uppercase text-gray-400">Score</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeGroup.scorers.map((s) => (
                              <tr key={`${activeGroup.attemptNumber}-${s.userId}`} className="border-b border-gray-50 last:border-b-0">
                                <td className="px-3 py-1.5 text-xs text-gray-500">{s.rank}</td>
                                <td className="px-3 py-1.5 text-xs text-gray-900">{s.name}</td>
                                <td className="px-3 py-1.5 text-xs text-gray-500 break-all">{s.email}</td>
                                <td className="px-3 py-1.5 text-xs text-right font-semibold text-gray-700">{s.score}%</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="text-xs text-gray-400 py-6 text-center">No attempts recorded for this assessment.</div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </Drawer>
  );
}

export default function DashboardApp() {
  const location = useLocation();
  const [tab, setTab] = useState('platform');
  const [selectedExamUsers, setSelectedExamUsers] = useState(null);
  const [selectedLeaderboard, setSelectedLeaderboard] = useState(null);

  const types = useSelector((state) => state.AssessmentType);
  const ASSESSMENT_EXAM_TYPES = useMemo(
    () => (types || [])
      .filter((item) => item.is_active && item.enable_user === true)
      .map((item) => ({ id: item.id, code: item.code })),
    [types]
  );
  const [period, setPeriod] = useState('90');
  const [platformData, setPlatformData] = useState(null);
  const [assessmentData, setAssessmentData] = useState(null);

  const [platformLoading, setPlatformLoading] = useState(false);
  const [assessmentLoading, setAssessmentLoading] = useState(false);

  const [revenueData, setRevenueData] = useState(null);
  const [revenueLoading, setRevenueLoading] = useState(false);
  const [revenuePage, setRevenuePage] = useState(1);

  // Restore dashboard state (tab, period, open exam-users panel) when returning
  // from the individual user view via the back button.
  useEffect(() => {
    const restore = location.state?.__dashboardReturn;
    if (restore) {
      setTab(restore.tab || 'assessments');
      if (restore.period) setPeriod(restore.period);
      setSelectedExamUsers(restore.selection || null);
      // Clear router state so a manual refresh doesn't keep re-restoring it.
      window.history.replaceState({}, document.title);
    }
  }, []);


  

  const tabs = [
    { id: 'platform', label: 'Platform Health' },
    { id: 'engagement', label: 'Engagement' },
    { id: 'revenue', label: 'B2C Revenue' },
    { id: 'clients', label: 'Client Admins' },
    { id: 'assessments', label: 'Assessments' },
    { id: 'assessmentsReports', label: 'Assessments Reports' }
  ];

  let periods =[];

  if(tab === 'platform'){
 periods = [
    { v: '7', l: 'Last 7 days' },
    { v: '30', l: 'Last 30 days' },
    { v: '90', l: 'Last 90 days' },
   
  ];
  }else{
 periods = [
    { v: '7', l: 'Last 7 days' },
    { v: '30', l: 'Last 30 days' },
    { v: '90', l: 'Last 90 days' },
    { v: '180', l: 'Last 180 days' },
    { v: '365', l: 'Last 365 days' },
  ];
  }

  useEffect(() => {
    let cancelled = false;

    const fetchPlatform = async () => {
      setPlatformLoading(true);
      setPlatformData(null);
      try {
        const res = await adminServices.getDashboardPlatform(period);
        if (cancelled) return;

        const raw = res.data.data;
        const { chartDates, activeUsers, newSignups } = fillDateGaps(Number(period), raw);
        const totalLogins = activeUsers.reduce((a, b) => a + b, 0);
        const totalSignups = newSignups.reduce((a, b) => a + b, 0);

        setPlatformData({
          chartDates,
          activeUsers,
          newSignups,
          totalB2CSubscribers: res.data?.total_b2c_subscribers,
          activeB2CLearners: totalLogins,
          newB2CSignups: totalSignups,
          totalB2BLearners: res.data?.total_b2b_learners,
        });
      } catch (err) {
        if (!cancelled) {
          console.error(err, 'failed to [getPlatformDetails]');
          setPlatformData(mockPlatformHealth);
        }
      } finally {
        if (!cancelled) setPlatformLoading(false);
      }
    };

    fetchPlatform();
    return () => { cancelled = true; };
  }, [period]);

  useEffect(() => {
    let cancelled = false;

    const fetchAssessments = async () => {
      setAssessmentLoading(true);
      setAssessmentData(null);
      try {
        const res = await adminServices.getDashboardAssessment(period);
        if (cancelled) return;

        const raw = res.data;
        const transformed = {
          totalUsers: Number(raw.summary.total_users),
          totalAttempts: Number(raw.summary.total_attempts),
          avgScore: Number(raw.summary.avg_score).toFixed(2),
          assessmentsInUse: raw.breakdown.filter(b => b.assessment_name).length,
          breakdown: raw.breakdown.map(b => ({
            id: b.id,
            name: b.assessment_name || 'Unknown / System',
            attempts: Number(b.total_attempts),
            uniqueUsers: Number(b.unique_users),
            avgScore: b.avg_score !== null ? Number(b.avg_score).toFixed(2) : '—',
            topScorerName: b.top_scorer_name || '—',
            topScorerScore: b.top_scorer_score !== null && b.top_scorer_score !== undefined
              ? Number(b.top_scorer_score).toFixed(2)
              : null,
          })),
        };

        setAssessmentData(transformed);
      } catch (err) {
        if (!cancelled) {
          console.error(err, 'failed to [getAssessmentDetails]');
          setAssessmentData(null);
        }
      } finally {
        if (!cancelled) setAssessmentLoading(false);
      }
    };

    fetchAssessments();
    return () => { cancelled = true; };
  }, [period]);


  const [clientAdminsData, setClientAdminsData] = useState(null);
  const [clientAdminsLoading, setClientAdminsLoading] = useState(false);
  const [clientAdminsError, setClientAdminsError] = useState('');
  const [clientAdminsPage, setClientAdminsPage] = useState(0);
  const CLIENT_ADMINS_PAGE_SIZE = 10;

  const fetchRevenue = useCallback(async (pageNum = 1) => {
    setRevenueLoading(true);
    if (pageNum === 1) {
      setRevenueData(null);
      setRevenuePage(1);
    }
    try {
      const res = await adminServices.getDashboardRevenue(period, pageNum, REVENUE_PAGE_SIZE);
      const raw = res.data;

      if (pageNum === 1) {
        setRevenueData({
          total_mrr: raw.total_mrr,
          new_subscriptions: raw.new_subscriptions,
          churn_rate: raw.churn_rate,
          currency: raw.currency,
          chart: raw.chart,
          plans: raw.plans,
          pagination: raw.pagination,
        });
      } else {
        setRevenueData(prev => ({
          ...prev,
          plans: raw.plans,
          pagination: raw.pagination,
        }));
        setRevenuePage(pageNum);
      }
    } catch (err) {
      console.error(err, 'failed to [fetchRevenue]');
      if (pageNum === 1) setRevenueData(null);
    } finally {
      setRevenueLoading(false);
    }
  }, [period]);

  useEffect(() => {
    fetchRevenue();
  }, [period]);

  const fetchClientAdmins = useCallback(async (pageNum = 0) => {
    setClientAdminsLoading(true);
    setClientAdminsError('');
    try {
      const res = await adminServices.getClientsDashboard(pageNum, CLIENT_ADMINS_PAGE_SIZE, '', 'all');
      if (res.ok) {
        const data = res.data;
        setClientAdminsData({
          summary: {
            totalTenants: Number(data.summary.totalTenants),
            activeTenants: Number(data.summary.activeTenants),
            b2bLearners: Number(data.summary.totalB2bLearners),
            totalARR: data.summary.totalAr,
          },
          tenants: data.tenants.map(t => ({
            id: t.id,
            name: t.tenantName,
            adminName: t.clientAdminName,
            adminEmail: t.clientAdminEmail,
            status: t.status,
            learners: Number(t.learnersCount),
            arr: t.arr,
            logo: t.logo,
          })),
          pagination: {
            page: data.pagination?.page || 0,
            size: data.pagination?.size || CLIENT_ADMINS_PAGE_SIZE,
            total: data.pagination?.total || 0,
            totalPages: data.pagination?.totalPages || 1,
          },
        });
        setClientAdminsPage(pageNum);
      } else {
        setClientAdminsError(res.data?.message || 'Failed to load client admins.');
        setClientAdminsData(null);
      }
    } catch (err) {
      setClientAdminsError('Failed to load client admins.');
      setClientAdminsData(null);
    } finally {
      setClientAdminsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchClientAdmins(0);
  }, []);

  return (
    <div className="font-sans bg-gray-100 min-h-screen text-gray-900 text-xs mt-16">
      <div className="bg-white border-b border-gray-200 px-5 pt-3 pb-0">
        <div className="flex items-start justify-between mb-3">
          <div>
            <div className="text-base font-bold text-gray-900">Dashboard</div>
            <div className="text-xs text-gray-500 mt-0.5">Platform metrics and analytics</div>
          </div>
        {tab !== 'assessmentsReports' &&
          <div className="flex border border-gray-200 rounded-md overflow-hidden h-7">
            {periods.map(({ v, l }) => (
              <button
                key={v}
                onClick={() => setPeriod(v)}
                className={`px-3 text-xs font-medium border-r border-gray-200 last:border-0 transition-colors cursor-pointer
        ${period === v ? 'bg-white-100 text-gray-900' : 'bg-gray-100 text-gray-500 hover:bg-gray-50'}`}
              >
                {l}
              </button>
            ))}
          </div>}
        </div>
        <div className="flex">
          {tabs.map(({ id, label }) => (
            <button
              key={id}
              onClick={() => setTab(id)}
              className={`px-4 py-2 text-xs font-medium border-b-2 -mb-px transition-colors cursor-pointer
                ${tab === id
                  ? 'text-blue-600 border-blue-600 font-semibold'
                  : 'text-gray-500 border-transparent hover:text-gray-700'
                }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="p-4 max-w-screen-3xl mx-auto">
        {tab === 'platform' && (<PlatformHealth data={platformData} loading={platformLoading} period={period} />)}
        {tab === 'engagement' && <Engagement period={period} />}   
        {tab === 'revenue' && (<Revenue data={revenueData} loading={revenueLoading} period={period} page={revenuePage} onPageChange={(newPage) => fetchRevenue(newPage)} />)}
        {tab === 'clients' && (
          <ClientAdminsSection
            data={clientAdminsData}
            loading={clientAdminsLoading}
            error={clientAdminsError}
            page={clientAdminsPage}
            onPageChange={(newPage) => fetchClientAdmins(newPage)}
            pageSize={CLIENT_ADMINS_PAGE_SIZE}
          />
        )}
        {tab === 'assessments' && (
        
          <Assessments
            data={assessmentData}
            loading={assessmentLoading}
            ASSESSMENT_EXAM_TYPES={ASSESSMENT_EXAM_TYPES}
            period={period}
            selectedExamUsers={selectedExamUsers}
            onSelectExam={setSelectedExamUsers}
            onCloseExamUsers={() => setSelectedExamUsers(null)}
            onViewLeaderboard={(row) => setSelectedLeaderboard({ id: row.id, name: row.name })}
          />
       
        
        )}
         {tab === 'assessmentsReports' && (
        
         <AssessmentUtils/>
       
        
        )}
      </div>
      <AssessmentLeaderboardDrawer
        selection={selectedLeaderboard}
        onClose={() => setSelectedLeaderboard(null)}
      />
    </div>
  );
}